import { FormattedMessage } from 'react-intl';

import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { messages } from '../messages';

import type { CriteriaInformations, FilterBy } from './types';

export const orderDateFilterBy: FilterBy = {
  id: 'orderDate',
  displayName: <FormattedMessage {...messages.orderDate} />,
  type: OptionFormTypes.TYPE_ORDER_DATE_COMPARISON,
  filterValue: 'orderDate',
  render: (criteriaInformations: CriteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_ORDER_DATE_COMPARISON, criteriaInformations);
  },
};
